module.exports = __webpack_public_path__ + "static/img/tabsbg03.cab9d7c5.png";